import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import GuestReportCardCopy from "./global/components/GuestReportCardCopy";
import InputBox from "./global/components/InputBox";
import Button from "./global/components/Button";
import Logo from "./assets/FastRealtyLogo.png";
import "./global/global.css";

const steps = [
  {
    heading: "Step 1: Sign Real Estate Agreement",
    subHeading: "Review and accept the terms to proceed.",
  },
  {
    heading: "Step 2: Prepare & List Your Property",
    subHeading: "Let's get your property ready for the market.",
  },
  {
    heading: "Step 3: Sign Closing Documents",
    subHeading: "Review and sign your closing documents to complete the transaction.",
  },
];

const GuestTasks = () => {
  const { id, pin } = useParams();
  const [valid, setValid] = useState(null);
  const [currentStep, setCurrentStep] = useState(1);
  const [chatInput, setChatInput] = useState("");
  const [chatMessages, setChatMessages] = useState([
    { from: "system", text: "Welcome to your guest tasks!" },
  ]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const validate = async () => {
      setLoading(true);
      try {
        const params = { request_id: id, request_pin: pin };
        const response = await axios.post(
          `${process.env.REACT_APP_PAYVIEW_BASE_URL}/api/guest/create_link_token`,
          params,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );
        if (!response.data.status_message) {
          setValid(true);
        } else {
          setValid(true);  // TODO: make this false
          setError(response.data.status_message || "Invalid link");
        }
      } catch (err) {
        setValid(true);  // TODO: make this false
        setError("Invalid or expired link.");
      } finally {
        setLoading(false);
      }
    };
    validate();
  }, [id, pin]);

  const handleSend = () => {
    if (chatInput.trim()) {
      setChatMessages([...chatMessages, { from: "user", text: chatInput }]);
      setChatInput("");
    }
  };

  if (loading) {
    return <div style={{ textAlign: "center", marginTop: 40 }}>Loading...</div>;
  }
  if (!valid) {
    return (
      <div style={{ textAlign: "center", marginTop: 40, color: "red" }}>
        {error || "Invalid or expired link."}
      </div>
    );
  }

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f9f9f9" }}>
      {/* Sidebar */}
      <div style={{ width: 320, background: "#fff", borderRight: "1px solid #eee", padding: 32 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <img src={Logo} alt="logo" style={{ height: 48 }} />
        </div>
        <div>
          {steps.map((step, idx) => (
            <div key={idx} style={{ marginBottom: 24 }}>
              <GuestReportCardCopy
                heading={step.heading}
                subHeading={step.subHeading}
                isActive={currentStep === idx + 1}
                isCompleted={currentStep === idx + 1}
                isChecked={currentStep === idx + 1}
                linkTxt={null}
                onClick={() => setCurrentStep(idx + 1)}
              />
            </div>
          ))}
        </div>
      </div>
      {/* Main Chat Window */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
        <div style={{ width: "100%", maxWidth: 600, margin: "40px auto", background: "#fff", borderRadius: 12, boxShadow: "0 2px 12px rgba(0,0,0,0.04)", padding: 32, minHeight: 400, display: "flex", flexDirection: "column" }}>
          <div style={{ flex: 1, overflowY: "auto", marginBottom: 24 }}>
            {chatMessages.map((msg, idx) => (
              <div key={idx} style={{ textAlign: msg.from === "user" ? "right" : "left", margin: "8px 0" }}>
                <span style={{
                  display: "inline-block",
                  background: msg.from === "user" ? "#28a382" : "#eee",
                  color: msg.from === "user" ? "#fff" : "#333",
                  borderRadius: 16,
                  padding: "8px 16px",
                  maxWidth: "80%",
                  wordBreak: "break-word",
                }}>{msg.text}</span>
              </div>
            ))}
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 8 }}>
            <input
              type="text"
              placeholder="Type your message..."
              value={chatInput}
              onChange={e => setChatInput(e.target.value)}
              style={{
                flex: 1,
                height: 48,
                border: '2px solid #d8d8d8',
                borderRadius: 10,
                padding: '0 16px',
                fontSize: 16,
                fontFamily: 'inherit',
                outline: 'none',
                minWidth: 0
              }}
              onKeyDown={e => { if (e.key === 'Enter') handleSend(); }}
            />
            <Button
              title="Send"
              txtColor="#fff"
              bgColor="#28a382"
              borderColor="1px solid #28a382"
              onClickFunc={handleSend}
              disabled={!chatInput.trim()}
              style={{ height: 48, padding: 0, fontSize: 16, borderRadius: 10 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestTasks; 